import { Component } from '@angular/core';

@Component({
    selector: 'cc-ngx-carousel-3d-slide',
    templateUrl: 'ngx-carousel-3d-slide.component.html',
    standalone: true,
})
export class NgxCarousel3dSlideComponent {}
